import { CategoryIcon, MusicLibraryIcon, StoriesIcon, WaveformIcon } from "@/components/appIcons";
import type { AppIcon } from "@/components/appIcons";
import type { FeaturePageFamily } from "@garimpa/lib/featurePage";

export const EDITORIAL_HUB_FAMILIES = [
  "collection",
  "story",
  "genre",
  "style",
] as const satisfies readonly FeaturePageFamily[];

export const EDITORIAL_HUB_FAMILY_PRESENTATION = {
  collection: {
    Icon: MusicLibraryIcon,
    className: "from-amber-500/35 via-orange-500/15 to-zinc-950 group-hover:border-amber-400/50",
    iconClassName: "bg-amber-300 text-amber-950",
  },
  story: {
    Icon: StoriesIcon,
    className: "from-fuchsia-500/30 via-rose-500/15 to-zinc-950 group-hover:border-fuchsia-400/50",
    iconClassName: "bg-fuchsia-300 text-fuchsia-950",
  },
  genre: {
    Icon: CategoryIcon,
    className: "from-orange-500/35 via-red-500/15 to-zinc-950 group-hover:border-orange-400/50",
    iconClassName: "bg-orange-300 text-orange-950",
  },
  style: {
    Icon: WaveformIcon,
    className: "from-cyan-500/30 via-sky-500/15 to-zinc-950 group-hover:border-cyan-400/50",
    iconClassName: "bg-cyan-300 text-cyan-950",
  },
} as const satisfies Record<
  FeaturePageFamily,
  { Icon: AppIcon; className: string; iconClassName: string }
>;
